import { Check, X } from "lucide-react";
import { Reveal, Eyebrow } from "./motion";

const ROWS = [
  {
    label: "Idratazione",
    cotton: "Assorbe e sottrae l'idratazione naturale a pelle e capelli",
    silk: "Preserva l'idratazione di pelle e capelli",
  },
  {
    label: "Attrito nel sonno",
    cotton: "Frizione elevata: nodi, rotture ed effetto crespo",
    silk: "Superficie liscia: il capello scivola senza stress",
  },
  {
    label: "Al risveglio",
    cotton: "Capelli disordinati e pieghe sul viso",
    silk: "Capelli più ordinati, morbidi e luminosi",
  },
  {
    label: "Temperatura",
    cotton: "Trattiene calore e umidità",
    silk: "Termoregolatrice: fresca d'estate, confortevole d'inverno",
  },
  {
    label: "Pelli sensibili",
    cotton: "Può accumulare acari e allergeni",
    silk: "Ipoallergenica e naturalmente protettiva",
  },
];

export const CotoneVsSeta = () => (
  <section data-testid="cotone-vs-seta" className="max-w-5xl mx-auto px-6 mt-20">
    <Reveal className="text-center max-w-2xl mx-auto">
      <Eyebrow className="justify-center">La differenza è strutturale</Eyebrow>
      <h2 className="mt-4 font-serif text-2xl sm:text-3xl lg:text-4xl text-plum tracking-tight">
        Cotone vs Seta: il confronto che convince
      </h2>
      <p className="mt-4 text-base sm:text-lg text-plum/60 leading-relaxed">
        Dormire sul cotone può vanificare tempo e cura investiti nei tuoi capelli. Ecco perché.
      </p>
    </Reveal>

    <Reveal delay={0.15}>
      <div className="mt-10 bg-white rounded-[2rem] border border-lilac-light overflow-hidden shadow-[0_20px_60px_-30px_rgba(46,16,101,0.25)]">
        <div className="grid grid-cols-[1fr_1fr_1fr] sm:grid-cols-[1.1fr_1.4fr_1.4fr]">
          <div className="p-4 sm:p-6" />
          <div className="p-4 sm:p-6 bg-mist text-center">
            <p className="font-serif text-lg sm:text-xl text-plum/50">Cotone</p>
            <p className="text-[10px] uppercase tracking-[0.18em] text-plum/40 font-bold mt-1">La federa comune</p>
          </div>
          <div className="p-4 sm:p-6 bg-lilac text-center relative">
            <span className="absolute -top-0 right-3 bg-matcha text-white text-[9px] font-bold uppercase tracking-[0.14em] px-2.5 py-1 rounded-b-lg">
              Consigliata
            </span>
            <p className="font-serif text-lg sm:text-xl text-highlight">Seta</p>
            <p className="text-[10px] uppercase tracking-[0.18em] text-plum/60 font-bold mt-1">Il trattamento notturno</p>
          </div>
        </div>
        {ROWS.map((row, i) => (
          <div
            key={row.label}
            data-testid={`vs-row-${i}`}
            className={`grid grid-cols-[1fr_1fr_1fr] sm:grid-cols-[1.1fr_1.4fr_1.4fr] border-t border-lilac-light/60 ${
              i % 2 === 1 ? "bg-lilac-soft/40" : ""
            }`}
          >
            <div className="p-4 sm:p-5 flex items-center">
              <p className="text-xs sm:text-sm font-bold text-plum">{row.label}</p>
            </div>
            <div className="p-4 sm:p-5 bg-mist/70 flex items-start gap-2">
              <X className="w-4 h-4 text-plum/30 shrink-0 mt-0.5" />
              <p className="text-xs sm:text-sm text-plum/50 leading-relaxed">{row.cotton}</p>
            </div>
            <div className="p-4 sm:p-5 bg-lilac/15 flex items-start gap-2">
              <Check className="w-4 h-4 text-matcha shrink-0 mt-0.5" />
              <p className="text-xs sm:text-sm text-plum font-medium leading-relaxed">{row.silk}</p>
            </div>
          </div>
        ))}
      </div>
    </Reveal>

    <Reveal delay={0.2}>
      <p className="mt-6 text-center font-serif italic text-lg text-plum/70">
        Il lusso che lavora mentre dormi.
      </p>
    </Reveal>
  </section>
);
